export const colors = {
    verde             : "#5bc500",
    azul              : "#0098d2",
    naranja           : "#ec6839",
    rojo              : "#ff374a",
    textBtnDisabled   : "#50535b",
    bgBtnDisabled     : "#f4f4f3"
};
